import type {
  WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto,
  WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto,
} from "../sdk/generated/models/index";

export const getVpsSubscriptionDescription = (
  subscription: WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultSubscriptionRestDto
) => {
  if (!subscription) {
    return "?";
  }

  return `${subscription?.memoryInGb} GB RAM, ${subscription?.cpuCount} CPU, ${subscription?.diskInGb} GB SSD`;
};

export const getStrippedVpsTemplateName = (
  template: WebhusetOrderApiFeaturesCatalogVpsGetResponse_CatalogVpsItemResultRestDto
) => {
  if (!template) {
    return "?";
  }

  return template.templateName
    ?.replaceAll(", 64 bits", "")
    .replaceAll(", 64 bit", "");
};
